<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span>اقلام فاکتور</span>
        <q-badge align="top" color="red" text-color="white" :label="factorInfo.Factor_Num"/>
        <q-chip :label="factorInfo.Cs_Name" square icon="person"/>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-if="factorInfo.ImmediatelySaleCustomer" class="no-padding text-center">
      <q-badge color="red" text-color="white" label="فروش فروشگاهی(فوری)"/>
      <q-space/>
      <q-chip square class="no-padding" dense>
        <q-chip size="sm" v-if="factorInfo.ImmediatelySaleCustomer" :label="factorInfo.Cs_Name" square/>
        <q-chip size="sm" v-if="factorInfo.ImmediatelySaleCustomer" icon="arrow_back" square/>
        <q-chip size="sm" v-if="factorInfo.ImmediatelySaleCustomer"
                :label="factorInfo.ImmediatelySaleCustomerName" square/>
      </q-chip>
    </q-card-section>
    <q-card-section class="text-center">
      <q-select v-model="selectedStore"
                :options="storeList"
                option-label="StorName"
                option-value="storeID"
                label="انبار"
                map-options emit-value filled />
    </q-card-section>
    <q-card-actions align="center">
      <q-btn v-if="items"
             :disable="(items.filter(item=> item.returnCount>0).length===0 ||
             items.filter(item=> item.returnCount > (parseFloat(item.SaleG_Count) - parseFloat(item.SaleG_BackCount ?? 0))).length>0)
             && !selectedStore"
             label="برگشت فاکتور"
             color="indigo"
             text-color="white"
             icon="check"
             @click="returnGoods"
      />
      <q-btn label="انصراف" flat color="red" v-close-popup/>
    </q-card-actions>
    <q-card-section class="no-padding">
      <q-table
          :data="items"
          row-key="Goods_ID"
          wrap-cells
          flat
          :hide-header="$q.screen.lt.md"
          :rows-per-page-options="[0]">
        <template v-slot:header>
          <q-tr class="text-bold">
            <td class="text-center">کد کالا</td>
            <td class="text-center">نام کالا</td>
            <td class="text-center">تعداد</td>
            <td class="text-center">تعداد قابل برگشت</td>
            <td class="text-center">تعداد برگشتی</td>
            <td class="text-center">واحد</td>
            <td class="text-center">قیمت واحد</td>
            <td class="text-center">قیمت کل</td>
            <td class="text-center">مبلغ برگشت</td>
            <td class="text-center">مالیات و ارزش افزوده</td>
            <td class="text-center">تخفیف</td>
          </q-tr>
          <q-tr class="bg-indigo text-white text-center">
            <td>{{ items.length }} قلم</td>
            <td></td>
            <td>{{ lodash.sumBy(items, "SaleG_Count") }}</td>
            <td>{{
                lodash.sumBy(items, item => parseFloat(item.SaleG_Count) - parseFloat(item.SaleG_BackCount ?? 0))
              }}
            </td>
            <td>{{ lodash.sumBy(items, item => parseFloat(item.returnCount)) }}</td>
            <td></td>
            <td></td>
            <td> {{
                (lodash.sumBy(items, item => parseInt(item.SaleG_Count) * parseInt(item.SaleG_PricePure))).toLocaleString()
              }}
            </td>
            <td> {{
                (lodash.sumBy(items, item => parseInt(item.returnCount) * parseInt(item.SaleG_PricePure))).toLocaleString()
              }}
            </td>
            <td>{{
                lodash.sumBy(items, item => parseInt(item.SaleG_Tax)).toLocaleString()
              }}
            </td>
            <td>{{
                lodash.sumBy(items, item => parseInt(item.SaleG_Off) * item.SaleG_Count).toLocaleString()
              }}
            </td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class text-center" v-if="!$q.screen.lt.md">
            <td>
              <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                      v-if="props.row.Goods_Code!=='109991'" color="red" text-color="white"
                      :label="props.row.Goods_Code"/>
            </td>
            <td class="text-left">
              {{ props.row.Goods_Name }}
              <q-space/>
              <q-chip color="indigo" text-color="white" :label="props.row.Group_Name"/>
            </td>
            <td>
              <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ props.row.SaleG_Count }}
              </q-badge>
            </td>
            <td>
              <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ parseFloat(props.row.SaleG_Count) - parseFloat(props.row.SaleG_BackCount ?? 0) }}
              </q-badge>
            </td>
            <td style="width: 120px">
              <q-input dir="ltr" v-model="props.row.returnCount" type="number"
                       filled/>
            </td>
            <td>
              <q-chip square color="brown" text-color="white" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ props.row.Unit_Name }}
              </q-chip>
            </td>
            <td>
              <q-chip text-color="white" square color="teal" class="q-ml-xs">
                {{ parseInt(props.row.SaleG_PricePure).toLocaleString() }}
                ریال
              </q-chip>
            </td>
            <td>
              <q-chip text-color="white" square color="teal-14" class="q-ml-xs">
                {{ (props.row.SaleG_Count * props.row.SaleG_PricePure) | toLoalString }}
                ریال
              </q-chip>
            </td>
            <td>
              <q-chip text-color="white" square color="teal-14" class="q-ml-xs">
                {{ (props.row.returnCount * props.row.SaleG_PricePure) | toLoalString }}
                ریال
              </q-chip>
            </td>
            <td class="text-center">
              <q-chip text-color="white" square color="teal-14" class="q-ml-xs">
                {{ (props.row.SaleG_Tax) | toLoalString }}
                ریال
              </q-chip>
            </td>
            <td v-if="props.row.Goods_Code!=='109991'">
              <q-chip square color="red" text-color="white"
                      :label="`${(parseInt(props.row.SaleG_Count) * parseInt(props.row.SaleG_Off)).toLocaleString()}`"/>
            </td>
          </q-tr>
          <q-tr :props="props" class="my-class" v-if="$q.screen.lt.md">
            <td>
              <q-card flat>
                <q-card-section class="no-padding">
                  <q-chip color="indigo" text-color="white" dense :label="props.row.Group_Name"/>
                  <q-space/>
                  <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                          v-if="props.row.Goods_Code!=='109991'" color="red" text-color="white"
                          :label="props.row.Goods_Code"/>
                  {{ props.row.Goods_Name }}
                  <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                    {{ props.row.SaleG_Count }}
                    ( {{ props.row.Unit_Name }})
                  </q-badge>
                  <q-space/>
                  <q-input dir="ltr" v-model="props.row.returnCount" type="number"
                           label="تعداد برگشت"
                           filled/>
                </q-card-section>
                <q-card-section class="no-padding text-center">
                  <q-chip text-color="white" square color="teal" class="q-ml-xs">
                    {{ parseInt(props.row.SaleG_PricePure).toLocaleString() }}
                    ریال
                  </q-chip>
                  <q-chip text-color="white" square color="teal" class="q-ml-xs">
                    {{ (props.row.SaleG_Count * parseInt(props.row.SaleG_PricePure)).toLocaleString() }}
                    ریال
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding text-center">
                  <span class="text-subtitle2">مالیات و ارزش افزوده</span>
                  <q-chip text-color="white" square color="teal-14" class="q-ml-xs">
                    {{ (props.row.SaleG_Tax) | toLoalString }}
                    ریال
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding text-center" v-if="props.row.Goods_Code!=='109991'">
                  <span class="text-subtitle2">تخفیف</span>
                  <q-chip square color="red" text-color="white"
                          :label="`${parseInt(props.row.SaleG_Off).toLocaleString()}`"/>
                </q-card-section>
              </q-card>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "ReturnBuyFactor",
  components: {ProductDetail},
  props: {
    factorInfo: {
      type: Object,
      required: false
    },
    saleNum: {
      type: Number,
      required: true
    },
    saleKind: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      items: [],
      showProductDetails: false,
      selectedProductDetails: undefined,
      invalidData: false,
      storeList: [],
      selectedStore:undefined
    }
  },
  methods: {
    ...mapActions({
      getItems: 'Buys/getFactorDetails',
      getProductInfo: 'Products/getProductInfo',
      issueFactor: 'Buys/issueBuyFacReturn',
      getStoreList: 'Products/getStoreList'
    }),
    returnGoods() {
      this.issueFactor({
        items: this.items,
        baseFactorNum: this.saleNum,
        storeId: this.selectedStore.StorID
      }).then((res) => {
        if (res.result===1){
          this.$q.notify({
            type:'positive',
            color:'positive',
            position:'top',
            message:'فاکتور برگشت از خرید صادر شد'
          })
          this.$emit('close-dialog')
        }
      })
    },
    checkValidData(rowInfo) {
      this.invalidData = rowInfo.SaleG_Count < rowInfo.returnCount
    },
    showProductDetailsDialog(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
  },
  created() {
    this.getStoreList().then((res) => {
      this.storeList = res
      this.selectedStore = this.storeList.filter(item=> item.StorID === this.factorInfo.Buy_StorID)[0]
    })
    this.getItems({
      Buy_Num: this.saleNum,
      Buy_Kind: this.saleKind
    }).then((res) => {
      res.forEach(rec => {
        rec.returnCount = 0
      })
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>